import { pipeu } from '@idem/common/pipeu';
import { validateNoSpaces } from '@idem/common/validators/validate-no-spaces';
import { validarFormatoDeNombreDeUsuario } from '@idem/common/validators/validar-formato-de-nombre-de-usuario';
import { validateMinLength } from '@idem/common/validators/validate-min-length';
import { validateMaxLength } from '@idem/common/validators/validate-max-length';

const LARGO_MINIMO = 4;
const LARGO_MAXIMO = 36;

export const validadorDeNombreDeUsuario = pipeu(
  validateNoSpaces,
  validarFormatoDeNombreDeUsuario,
  validateMinLength(LARGO_MINIMO),
  validateMaxLength(LARGO_MAXIMO),
);
